import React, { useEffect, useState }  from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Cascader } from 'antd';
import mapper from 'object-mapper';
import { fetchBaseInfo } from '@/Actions/Baseinfo';

export default (props) => {
  const dispatch = useDispatch();

  const [shopsMapped, setShopsMapped] = useState({});
  const [platformShopOptions, setPlatformShopOptions] = useState([]);
  const platformShops = useSelector((state) => state.get('Baseinfo').get('shops'));
  useEffect(() => {
    if  ((platformShops?.size || platformShops?.length || 0) === 0) dispatch(fetchBaseInfo('shops'));
    else {
      setShopsMapped(platformShops.reduce((a, c) => (a[c.key] = c, a), {}));
      const _platformShopOptions = platformShops.map((pf) => ({
        ...pf,
        shop: pf.shop.map((s) => ({
          ...s,
          disabled: props.disabledSelect ? s?.status === 0 : false,
          label: (props.hideTitle) ? (s?.desc || s.label) : s.label,
          code: `${pf.code || ''} ${s?.desc === s.label ? s.code : ''}`,
        })),
      }));
      setPlatformShopOptions(_platformShopOptions);
    }
    return () => {};
  }, [platformShops, props.hideTitle, props.disabledSelect]);

  const [value, setValue] = useState([]);
  useEffect(() => {
    const _v = props?.multiple || false ? [] : (props?.value || []).filter(s => s).map((e) => Number(e));
    if ((props?.multiple || false) === false) {
      setValue(_v);
    }
    return () => {};
  }, [props]);


  const handleChange = (values) => {
    setValue(values);
    const platformShopsMapper = {
      'platform_shop_id': [
      {
        'key': 'shop_id',
        'transform': (value) => {
          return Array.isArray(value) && Array.isArray(value[0])
            ? value
                .map((_arr) => _arr.length===1 ? shopsMapped[_arr[0]].shop.map(e => e.key) : _arr[1])
                // .filter((s) => s)
                .join(',')
            : (value || [])[1] ?? '';
        }
      },
      {
        'key': 'web_source',
        'transform': (value) =>
          Array.isArray(value) && Array.isArray(value[0])
            ? [...(new Set(value.map((_arr) => _arr[0]).filter(s => s)))].join(',')
            : (value || [])[0] ?? ''
      },
    ]};
    const dest = mapper({'platform_shop_id': values}, platformShopsMapper);
    props.onChange([dest.web_source, dest.shop_id]);
  }

  return (
    <>
    <Cascader
      {...props}
      options={platformShopOptions}
      fieldNames={{ value: 'key', children: 'shop' }}
      expandTrigger="hover"
      dropdownClassName="cascader-shop"
      popupClassName="cascader-shop"
      changeOnSelect
      showCheckedStrategy={Cascader.SHOW_CHILD}
      onChange={handleChange}
      value={value}
      maxTagCount={props?.maxTagCount || 2}
      maxTagPlaceholder={(omittedValues) => ` + ${omittedValues.length} 更多...`}
      />
    </>
  );
}
